export default "__VITE_ASSET__1fb85291__"